/* AVORA — Quick Add to Cart
   Single-variant: POST to cart API, show checkmark.
   Multi-variant: navigate to product page. */
(function() {
  function shopPath(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/' + String(path || '').replace(/^\//, '');
  }

  function announce(btn, message) {
    var card = btn.closest('.avora-card');
    var status = card ? card.querySelector('[data-avora-card-status]') : null;
    if (status) status.textContent = message || '';
  }

  function initAvoraQuickAdd() {
    document.querySelectorAll('.avora-card__quick-add').forEach(function(btn) {
      if (btn.dataset.avoraInit) return;
      btn.dataset.avoraInit = 'true';

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (btn.disabled) return;

        var hasOnlyDefault = btn.dataset.hasOnlyDefault === 'true';
        if (!hasOnlyDefault) {
          window.location.href = btn.dataset.productUrl;
          return;
        }

        var variantId = btn.dataset.variantId;
        var quantity = Math.max(1, parseInt(btn.dataset.quantity || '1', 10) || 1);
        btn.style.pointerEvents = 'none';
        announce(btn, window.AvoraI18n.text('Adding item to cart.'));

        fetch(shopPath('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] })
        })
        .then(function(res) {
          return res.json().catch(function() { return {}; }).then(function(data) {
            if (!res.ok) throw new Error(data.description || data.message || window.AvoraI18n.text('We could not add this item. Please try again.'));
            return data;
          });
        })
        .then(function(payload) {
          btn.classList.add('success');
          announce(btn, window.AvoraI18n.text('Item added to cart.'));
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'collection-card', payload: payload } }));

          /* Trigger fly-to-cart animation */
          if (window.avoraFlyToCart) {
            var card = btn.closest('.avora-card');
            var imgEl = card ? card.querySelector('img') : null;
            var titleEl = card ? card.querySelector('.avora-card__title') : null;
            var priceEl = card ? card.querySelector('.avora-card__price') : null;
            window.avoraFlyToCart({
              imageEl: imgEl,
              imageSrc: imgEl ? imgEl.src : '',
              title: titleEl ? titleEl.textContent.trim() : '',
              price: priceEl ? priceEl.textContent.trim() : '',
              sourceEl: btn
            });
          }

          /* Update cart count in header */
          fetch(shopPath('cart.js'), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.querySelectorAll('.cart-count-badge, [data-cart-count], .cart-bubble__text-count').forEach(function(el) {
                el.textContent = cart.item_count;
                el.classList.remove('hidden');
                var bubble = el.closest('.cart-bubble');
                if (bubble) bubble.classList.remove('visually-hidden');
              });
            });

          setTimeout(function() {
            btn.classList.remove('success');
            btn.style.pointerEvents = '';
          }, 1500);
        })
        .catch(function(error) {
          btn.style.pointerEvents = '';
          announce(btn, error && error.message ? error.message : window.AvoraI18n.text('We could not add this item. Please try again.'));
        });
      });
    });
  }

  window.avoraInitCollectionCards = initAvoraQuickAdd;

  /* Also keep the legacy function for backward compat */
  window.avoraQuickAdd = function(btn) {
    var variantId = btn.dataset.variantId;
    var quantity = Math.max(1, parseInt(btn.dataset.quantity || '1', 10) || 1);
    var textEl = btn.querySelector('.avora-card__add-text');
    if (textEl) textEl.textContent = 'Adding...';
    btn.disabled = true;

    fetch(shopPath('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] })
    })
    .then(function(res) {
      return res.json().catch(function() { return {}; }).then(function(data) {
        if (!res.ok) throw new Error(data.description || data.message || window.AvoraI18n.text('We could not add this item. Please try again.'));
        return data;
      });
    })
    .then(function() {
      if (textEl) textEl.textContent = 'Added \u2713';
      fetch(shopPath('cart.js'), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('.cart-count-badge, [data-cart-count]').forEach(function(b) {
            b.textContent = cart.item_count;
          });
        });
      setTimeout(function() {
        if (textEl) textEl.textContent = window.AvoraI18n.text('Add to cart');
        btn.disabled = false;
      }, 2000);
    })
    .catch(function(error) {
      if (textEl) textEl.textContent = 'Error \u2014 retry';
      announce(btn, error && error.message ? error.message : window.AvoraI18n.text('We could not add this item. Please try again.'));
      btn.disabled = false;
    });
  };

  /* Scroll reveal with column-based stagger */
  function initCardReveal() {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var card = entry.target;
          var grid = card.closest('.avora-sc-products__grid, .avora-col-products__grid');
          if (grid) {
            var cards = Array.from(grid.children);
            var idx = cards.indexOf(card.closest('.avora-sc-products__item') || card);
            var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
            var colIdx = idx % cols;
            card.style.transitionDelay = (colIdx * 60) + 'ms';
          }
          card.classList.add('avora-visible');
          observer.unobserve(card);
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.avora-card:not(.avora-visible)').forEach(function(card) {
      observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAvoraQuickAdd();
      initCardReveal();
    });
  } else {
    initAvoraQuickAdd();
    initCardReveal();
  }

  /* Re-init on Shopify editor section reload */
  document.addEventListener('shopify:section:load', function() {
    initAvoraQuickAdd();
    initCardReveal();
  });
})();
